<div class="rootdiv" style="color: black">
  <patron-tabview
    [tabs]="[
      { header: 'Requisitos', template: requirementsTemplate },
      { header: 'ID Commit', template: revisionsTemplate },
    ]">
    <ng-template #requirementsTemplate>
      <requirements-tab [unconfirmedTicket]="unconfirmedTicket" [user]="user"></requirements-tab>
    </ng-template>

    <ng-template #revisionsTemplate>
      <revisions-tab [unconfirmedTicket]="unconfirmedTicket" [user]="user"></revisions-tab>
    </ng-template>
  </patron-tabview>

  <!-- <tabset>
  
      <tab (selectTab)="changeTab($event)" [id]="tabIds[0]">
        <ng-template tabHeading>
          <i class="fa fa-list-ol"></i>
          <span class="d-none d-md-inline ml-1">Requisitos</span>
        </ng-template>
  
        <requirements-tab
          [unconfirmedTicket]="unconfirmedTicket"
          [user]="user"
        ></requirements-tab>
      </tab>
  
      <tab (selectTab)="changeTab($event)" [id]="tabIds[1]">
        <ng-template tabHeading>
          <i class="fa fa-code-fork"></i>
          <span class="d-none d-md-inline ml-1">ID Commit</span>
        </ng-template>
  
        <revisions-tab
          [unconfirmedTicket]="unconfirmedTicket"
          [user]="user"
        ></revisions-tab>
      </tab>
  
    </tabset> -->
</div>
